<div class="w-100 details-container">
  <div>
    @switch (entityType) {
      @case ('machines') {
        <div>
          @if (serialNumber) {
            <ul class="nav nav-tabs" [ngClass]="isLight ? 'light' : 'dark'">
              @for (tab of tabs; track tab; let i = $index) {
                <li class="nav-item m-0 d-flex align-items-center tab-title">
                  <button
                    class="nav-link fw-semibold d-flex align-items-center gap-2"
                    [ngClass]="[selectedTab === i ? 'active' : '', isLight ? 'light' : 'dark']"
                    aria-current="page"
                    data-bs-toggle="tab"
                    attr.data-bs-target="{{ '#' + tab }}"
                    type="button"
                    role="tab"
                    attr.aria-controls="{{ tab }}"
                    aria-selected="true"
                    (click)="switchTab(i)"
                  >
                    <app-icam-icon
                      [iconName]="
                        tab.icon +
                        (isLight ? (selectedTab === i ? '-dark' : '-light') : selectedTab === i ? '-light' : '-dark')
                      "
                      [iconHeight]="'14px'"
                      class="nav-link-icon"
                    />
                    <p class="m-0 p-0" [ngClass]="">
                      {{ 'TABLE.DETAILS.' + tab.tabName + '.title' | translate }}
                    </p>
                  </button>
                  @if (selectedTab === i) {
                    <div class="arrow-down">
                      <app-icam-icon iconName="chevron-down" [iconHeight]="'10px'" />
                    </div>
                  }
                </li>
              }
            </ul>
            <div class="tab-content" id="nav-tabContent">
              @for (tab of tabs; track tab; let i = $index) {
                @if (selectedTab === i) {
                  <div [id]="tab.tabName" class="tab-pane mt-4 active">
                    <div>
                      @switch (tab.tabName) {
                        @case ('informations') {
                          <div>
                            <app-machine-informations [serialNumber]="serialNumber!" />
                          </div>
                        }
                        @case ('performances') {
                          <div>
                            <app-machine-performances [serialNumber]="serialNumber" />
                          </div>
                        }
                      }
                    </div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
      @case ('closed_tickets') {
        <div>
          <div class="d-none d-lg-flex justify-content-center w-100">
            <div
              class="resolution border-0 d-flex justify-content-center gap-2"
              [ngStyle]="{
                width: 'calc(100% - calc(' + cssConfig.table.detailsPosition + ' + 3px))'
              }"
            >
              <p class="fw-semibold text-center m-0">{{ 'TABLE.DETAILS.shared.resolution' | translate }}</p>
              <p class="text-start m-0">{{ resolution || 'TICKET.NO_SOLUTION' | translate }}</p>
            </div>
          </div>
          <div class="d-flex d-lg-none mt-3 w-100 gap-2 align-items-center justify-content-between">
            <p class="fw-bold pe-2 text-center m-0">{{ 'TABLE.DETAILS.shared.resolution' | translate | uppercase }}</p>
            <p class="flex-grow-1 text-end m-0">{{ resolution || 'TICKET.NO_SOLUTION' | translate }}</p>
          </div>
        </div>
      }
      @case ('requests') {
        <div>
          <div class="d-none d-lg-flex justify-content-center w-100">
            <div
              class="resolution border-0 d-flex justify-content-center gap-2"
              [ngStyle]="{
                width: 'calc(100% - calc(' + cssConfig.table.detailsPosition + ' + 3px))'
              }"
            >
              <p class="fw-semibold text-center m-0">{{ 'TABLE.DETAILS.shared.description' | translate }}</p>
              <p class="text-start m-0">{{ description || ('REQUEST.NO_DESCRIPTION' | translate) }}</p>
            </div>
          </div>
          <div class="d-flex d-lg-none mt-3 w-100 gap-2 align-items-center justify-content-between">
            <p class="fw-bold pe-2 text-center m-0">{{ 'TABLE.DETAILS.shared.description' | translate | uppercase }}</p>
            <p class="flex-grow-1 text-end m-0">{{ description || ('REQUEST.NO_DESCRIPTION' | translate) }}</p>
          </div>
        </div>
      }
    }
  </div>

  <div class="w-100 d-flex justify-content-end" [ngClass]="{ 'mt-3': hasClosingBtn }">
    @if (hasClosingBtn) {
      <button
        (click)="onCloseDetails()"
        [ngClass]="[!showDetails ? cssConfig.table.buttonHide : cssConfig.table.buttonShow, isLight ? 'light' : 'dark']"
      >
        {{
          (!showDetails
            ? 'TABLE.BUTTONS.' + entityType + '.hideDetails'
            : 'TABLE.BUTTONS.' + entityType + '.showDetails'
          ) | translate
        }}
      </button>
    }
  </div>
</div>
